var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushSize2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35688 6.2767C6.11252 6.55093 5.88379 6.91524 5.72051 7.26603C5.02133 8.76813 3.23684 9.41902 1.73473 8.71984C0.232633 8.02066 -0.418261 6.23616 0.280922 4.73406C0.644524 3.95291 1.17601 3.07209 1.87722 2.28513C2.56241 1.51616 3.56321 0.666061 4.89493 0.250066C6.34304 -0.202287 7.91294 -0.0519963 9.37383 0.791401C10.7292 1.57388 11.8454 2.86307 12.8007 4.45947C13.1967 5.12104 13.5188 5.52043 13.7447 5.75448C13.923 5.50952 14.0907 5.19815 14.2143 4.88834C14.8283 3.34944 16.5735 2.59965 18.1124 3.21363C19.6513 3.82761 20.4011 5.57286 19.7871 7.11175C19.4755 7.8929 19.0058 8.78524 18.3634 9.59032C17.7404 10.3711 16.7862 11.2793 15.4534 11.729C13.98 12.2262 12.4067 12.0381 10.9826 11.1808C9.67633 10.3946 8.59347 9.11327 7.6523 7.54062C7.1436 6.6906 6.75129 6.28282 6.53061 6.10034C6.48201 6.14411 6.42374 6.20167 6.35688 6.2767Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushSize2);
export default __webpack_public_path__ + "static/media/brush_size2.39211e8c5fe6c816ede51dbec49b9e2c.svg";
export { ForwardRef as ReactComponent };